import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { useIntl, getLocale } from 'umi';
import { Table } from 'tea-component';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import MarketTable from './MarketTable';
import useChangeSize from '@/pages/intelligence/hooks/useChangeSize';
import { changeMulRankTitle } from '../../utils';

const { expandable } = Table.addons;

// StoreRank 多个国家列表
export default function StoreMultipleTable(props: any) {
  const { list, showHeatMap, cloumnsLen } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const size = useChangeSize();

  const tableRef = useRef<any>(null);
  // 当前排序列
  const [columns, setColumns] = useState<any[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<any[]>([]);
  const [activeExpandedKeys, setActiveExpandedKey] = useState<any[]>([]);

  const openClick = (keys: any) => {
    setExpandedKeys(keys);
    setActiveExpandedKey(keys ? keys[keys?.length - 1] : '');
  };

  useEffect(() => {
    const _columns = [];
    const tableWidth = tableRef?.current?.clientWidth;
    const rankText = formatMessage({ id: 'dbi_rank' });
    _columns.push({
      key: 'rank_type',
      width: 154 - 26,
      header: () => <>{rankText}</>,
      render: (cvm: any) => `${rankText} ${changeMulRankTitle(cvm.rank_type)}`,
    });

    for (let i = 0; i < cloumnsLen; i++) {
      /** 配置columns */
      _columns.push({
        key: i,
        header: () => <>{i}</>,
        align: 'center',
        width: i === 5 && tableWidth > 200 ? (tableWidth - 198) / 6 : undefined,
        render: (cvm: any) => (
          <div
            className={classnames('dbi-table-list-item__text', {
              'dbi-table-list-item-heatmap':
                showHeatMap && (list?.length === 1 || cvm[`isMax${i}`]) && cvm[`value_game${i}`],
            })}
          >
            {cvm[`value_game${i}`] || '-'}
          </div>
        ),
      });
    }
    // if (cloumnsLen < 6) {
    //   _columns.push({
    //     key: 'ikey',
    //     width: tableWidth > 200 ? (tableWidth - 198) / 6 : 'auto',
    //     header: () => <></>,
    //     render: () => <></>,
    //   });
    // }
    setColumns(_columns);
  }, [locale, JSON.stringify(list), size, activeExpandedKeys]);

  return (
    <div className="dbi-countries-table--mul" ref={tableRef}>
      <Abnormal
        isLoading={false}
        isNoData={!list?.length}
        component={
          <Table
            hideHeader={true}
            records={list}
            recordKey="rank_type"
            columns={[...columns]}
            addons={[
              expandable({
                expandedKeys,
                onExpandedKeysChange: (keys, { event }) => {
                  event?.stopPropagation();
                  openClick(keys);
                },
                render() {
                  return (
                    <MarketTable
                      expandedKeys={expandedKeys}
                      cloumnsLen={cloumnsLen}
                      activeExpandedKeys={activeExpandedKeys}
                      list={list}
                    />
                  );
                },
              }),
            ]}
          />
        }
      />
    </div>
  );
}
